import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

interface ModalConfirmProps {
  question: string;
  onConfirm: () => void;
  onDecline: () => void;
  closeModal: () => void;
}

const ConfirmationModal: React.FC<ModalConfirmProps> = ({
  question,
  onConfirm,
  onDecline,
  closeModal,
}) => {
  const dispatch = useDispatch();


  return (
    <div className="creationForm">
      <div className="modalHeading gridCenter">
        <h3>{question}</h3>
      </div>
      <form>
        {/* Кнопки действий */}
        <div className="flex gap12" style={{
            justifyContent: "center"
        }}>
          <button
            className="filterButton"
            type="button"
            onClick={() => { onConfirm(); closeModal();}}
          >
            Да
          </button>
          <button className="cancelButton" type="button" onClick={() => { onDecline(); closeModal();}}>
            Нет
          </button>
        </div>
      </form>
    </div>
  );
};

export default ConfirmationModal;
